import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Chip,
  Typography,
  makeStyles,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  item: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8,
    marginBottom: 8,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  hint: {
    color: theme.palette.text.secondary,
    fontSize: 13,
    marginBottom: 12,
  },
}));

/**
 * Escolha de canal/conexão para ligação quando o usuário tem acesso a mais de um token de voz.
 */
export default function VoiceChannelPicker({
  open,
  channels = [],
  selectedId,
  onSelect,
  onClose,
  title = "Escolher canal para ligar",
}) {
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography className={classes.hint}>
          Você tem acesso a mais de uma conexão com voz. Escolha qual canal usar.
          (Definido em Conexões → quem pode ver/fazer ligações.)
        </Typography>
        <List disablePadding>
          {channels.map((ch) => (
            <ListItem
              key={ch.id}
              className={classes.item}
              selected={Number(selectedId) === Number(ch.id)}
              onClick={() => onSelect(ch)}
              button
            >
              <ListItemText
                primary={ch.name || `Conexão #${ch.id}`}
                secondary={
                  ch.channel === "whatsapp_oficial"
                    ? "WhatsApp Oficial"
                    : ch.isMfv
                      ? "Multiflow Voz"
                      : "WaVoIP"
                }
              />
              <ListItemSecondaryAction>
                <Chip
                  size="small"
                  label={ch.connected ? "Conectado" : "Off"}
                  color={ch.connected ? "primary" : "default"}
                />
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
        {!channels.length && (
          <Typography color="textSecondary">
            Nenhuma conexão de voz liberada para o seu usuário.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
      </DialogActions>
    </Dialog>
  );
}
